import styled from 'styled-components';
import { tabletOrSmaller, laptopOrBigger } from '../../utils/media-query';
import { Gray, White } from '../../colors';
export const Overlay = styled.div `
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000000;
  ${laptopOrBigger `
    align-items: center;
  `}
`;
export const ModalForm = styled.main.withConfig({
    componentId: 'GMv2_ModalForm',
}) `
  ${tabletOrSmaller `
    height: 600px;
    width: 324px;
  `}
  ${laptopOrBigger `
    height: 540px;
    width: 500px;
  `}
  box-sizing: border-box;
  border: 1px solid ${Gray.light};
  border-radius: 6px;
  background-color: ${White.normal};
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: column;
`;
//# sourceMappingURL=GenericModalV2.Styled.js.map